// Selecteer vestiging met jQuery UI Autocomplete
(function( $ ) {

  $(document).ready(function() {
	function assign(element, item, mode) {
		if(item) {
			element.val( item.label );
			var dependants = $('input, select').filter('[data-search='+element[0].id+'][id]').each(function() { $(this).val(item[$(this).attr('id').replace(/.*-/, '')]||'') })
		}
		else {
			element.val( '' );
			var dependants = $('input[data-search='+element[0].id+']').val( '' );
		}
		element.trigger('sitesearch.assign', [item, mode]);
		setTimeout(function() { element.add(dependants).change() });
	}

	function proceed(term) {
		return term.match(/[a-z\u0080-\uffff]{2}/i);
	}
	function filter(array, term, exact) {
		var m = term!=null && term.match(/^\s*(\S.*)?\s*$/);
		var re = m && m[1] ? $.ui.autocomplete.escapeRegex(m[1].replace(/\'+/g, '').replace(/[\s\-,]+/g, ' ')) : '';
		re = exact ? '^'+re+'$' : '(^|\\s|[\\(,/])' + re;
		var matcher = new RegExp( re, "i" );
		var r = $.grep( array, function(value) {
			value = (value.label || value.value || value).toString().replace(/\'+/g, '').replace(/[\s\-,]+/g, ' ');
			return matcher.test( value );
		});
		return r;
	}

	$("input.gm-sitesearch").autocomplete({
		delay: 30,
		minLength: 1,

		change: function(event, ui) {
			var that = $(this).data('ui-autocomplete');
			if(ui.item === null){
				var item = proceed(that.term) && filter(that.latest||that.options.list||[], that.term, !that.latest || that.latest.length > 1)[0];
				if(item) {
					assign($(this), item, 'change');
				}
				else {
					that.value = that.term;
					assign($(this), null, 'change');
					if(!that.xhr && proceed(that.value)) {
						that._search( that.value );
					}
				}
			}
		},
		select: function( event, ui ) {
			assign($(this), ui.item, 'select');
			return false;
		},
		focus: function (event, ui) {
			if(ui.item.label != undefined){
				this.value = ui.item.label;
			}
			event.preventDefault(); // Prevent the default focus behavior.
		},
		source: function( request, response ) {
			var that = this;

			if(!this.options.list) {
				return response(this.latest = null);
			}

			response(this.latest = filter(this.options.list, request.term));
		}
	}).focus(function(){
		$(this).data('placeholder',$(this).attr('placeholder')).attr('placeholder','');
		$(this).autocomplete('search')
	}).blur(function(){
		$(this).attr('placeholder',$(this).data('placeholder'));
	})
		// expand on focus
	.keypress(function (event) { if(event.keyCode==13) { event.preventDefault(); this.blur(); } })  // pressed return
	.each(function() { $(this).autocomplete('option', 'appendTo', $(this).closest('form, body')) })
  })
})( jQuery );
